import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL;

const api = axios.create({ baseURL: '', withCredentials: true });

export const fetchFacility = () => api.get('/api/facility').then(r => r.data);
export const fetchPackages = () => api.get('/api/birthday-packages').then(r => r.data);
export const fetchPackage = (id) => api.get(`/api/birthday-packages/${id}`).then(r => r.data);
export const fetchTunnels = () => api.get('/api/tunnels').then(r => r.data);
export const fetchSports = () => api.get('/api/sports').then(r => r.data);
export const fetchTournaments = () => api.get('/api/tournaments').then(r => r.data);
export const fetchGallery = () => api.get('/api/content/gallery').then(r => r.data);
export const fetchVideos = () => api.get('/api/content/videos').then(r => r.data);
export const fetchEvents = () => api.get('/api/content/events').then(r => r.data);
export const fetchFaqs = () => api.get('/api/faq').then(r => r.data);
export const submitContact = (data) => api.post('/api/contact', data).then(r => r.data);
export const submitTournamentInquiry = (data) => api.post('/api/tournament-inquiry', data).then(r => r.data);

// Admin
export const adminGetGallery = () => api.get('/api/admin/gallery').then(r => r.data);
export const adminAddGallery = (data) => api.post('/api/admin/gallery', data).then(r => r.data);
export const adminDeleteGallery = (id) => api.delete(`/api/admin/gallery/${id}`).then(r => r.data);
export const adminGetVideos = () => api.get('/api/admin/videos').then(r => r.data);
export const adminAddVideo = (data) => api.post('/api/admin/videos', data).then(r => r.data);
export const adminDeleteVideo = (id) => api.delete(`/api/admin/videos/${id}`).then(r => r.data);
export const adminGetEvents = () => api.get('/api/admin/events').then(r => r.data);
export const adminAddEvent = (data) => api.post('/api/admin/events', data).then(r => r.data);
export const adminUpdateEventStatus = (id, status) => api.put(`/api/admin/events/${id}/status`, { status }).then(r => r.data);
export const adminDeleteEvent = (id) => api.delete(`/api/admin/events/${id}`).then(r => r.data);

// Packages
export const adminGetPackages = () => api.get('/api/admin/packages').then(r => r.data);
export const adminAddPackage = (data) => api.post('/api/admin/packages', data).then(r => r.data);
export const adminUpdatePackage = (id, data) => api.put(`/api/admin/packages/${id}`, data).then(r => r.data);
export const adminDeletePackage = (id) => api.delete(`/api/admin/packages/${id}`).then(r => r.data);

// FAQ
export const adminGetFaqs = () => api.get('/api/admin/faq').then(r => r.data);
export const adminAddFaq = (data) => api.post('/api/admin/faq', data).then(r => r.data);
export const adminUpdateFaq = (id, data) => api.put(`/api/admin/faq/${id}`, data).then(r => r.data);
export const adminDeleteFaq = (id) => api.delete(`/api/admin/faq/${id}`).then(r => r.data);

// Hero settings
export const fetchHeroSettings = () => api.get('/api/hero-settings').then(r => r.data);
export const adminGetHeroSettings = () => api.get('/api/admin/hero-settings').then(r => r.data);
export const adminUpdateHeroSettings = (data) => api.put('/api/admin/hero-settings', data).then(r => r.data);
export const adminUploadFile = (file) => {
  const formData = new FormData();
  formData.append('file', file);
  return api.post('/api/admin/upload', formData, { headers: { 'Content-Type': 'multipart/form-data' } }).then(r => r.data);
};

export default api;
